import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDateTimePicker } from '@mui/x-date-pickers/StaticDateTimePicker';
import dayjs, { Dayjs } from 'dayjs';
import { FC, useMemo } from 'react';

interface DateTimeCalendarProps {
  value: Date;
  onChange: (date: Date) => void;
  style?: React.CSSProperties;
}

export const DateTimeCalendar: FC<DateTimeCalendarProps> = ({ value, onChange, style }) => {
  const pickerValue = useMemo(() => {
    return dayjs(value);
  }, [value]);

  const handleDateChange = (newValue: Dayjs | null) => {  
    const newDate = newValue ? newValue.toDate() : new Date();
    onChange(newDate);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StaticDateTimePicker
        value={pickerValue}
        onChange={handleDateChange}
        slots={{
          toolbar: () => <></>,
          actionBar: () => <></>,
        }}
        sx={{
          ...style,
          width: '100%',
          backgroundColor: 'transparent',
          '& .MuiDateCalendar-root': {
            width: '100%',
            maxWidth: 'none', 
          },
          '& .MuiPickersCalendarHeader-root': {
            paddingLeft: 0,
            paddingRight: 0
          },
          '& .MuiDayCalendar-header': {
            justifyContent: 'space-between',
          },
          '& .MuiDayCalendar-weekContainer': {
            justifyContent: 'space-between',
          },
          '& .MuiPickersLayout-root': { 
            width: '100%',
            maxWidth: 'none', 
          },
          '& .MuiPickerStaticWrapper-root': {
            backgroundColor: 'var(--tg-bg-color)', 
            width: '100%', 
            maxWidth: 'none',
          },
          '& .MuiDayCalendar-weekDayLabel': { 
            color: 'var(--tg-theme-text-color)', 
            fontSize: '0.875rem', 
          },
          '& .MuiPickersDay-root': {
            color: 'var(--tg-theme-text-color)',
            width: '40px', 
            height: '40px', 
            fontSize: '1rem', 
            '&.Mui-selected': {
              backgroundColor: 'var(--tgui--button_color)',
              color: 'var(--tg-theme-button-text-color)',
              '&:hover': {
                backgroundColor: 'var(--tgui--button_color)',
              },
            },
            '&:hover': {
              backgroundColor: 'var(--tg-theme-secondary-bg-color)',
            },
          },
          '& .MuiPickersCalendarHeader-label': { 
            color: 'var(--tg-theme-text-color)',
            fontSize: '1.1rem', 
          },
          '& .MuiSvgIcon-root': { 
            color: 'var(--tg-theme-text-color)',
            fontSize: '1.5rem', 
          },
          '& .MuiClockNumber-root': { 
            fontSize: '1.1rem', 
          },
          '& .MuiTimeClock-amButton, & .MuiTimeClock-pmButton': { 
            fontSize: '1rem'
          },
        }}
        ampm={false}
        orientation="portrait" 
      />
    </LocalizationProvider>
  );
}; 